import { render, staticRenderFns } from "./InjectionEdit.vue?vue&type=template&id=96b41cdc&"
import script from "./InjectionEdit.vue?vue&type=script&lang=js&"
export * from "./InjectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./InjectionEdit.vue?vue&type=style&index=0&id=96b41cdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports